export function section13() {
    const video = document.querySelector('section.slice-13 video');

    // create intersection observer to pause video if not in view
    let observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) {
            video.pause()
        }
    });

    observer.observe(document.querySelector("section.slice-13"))
}
